const apiCache = new Map();

export const fetchFromCacheOrAPI = async (force, cacheKey, apiFunction, ...apiArgs) => {
  if (!force && apiCache.has(cacheKey)) {
    return apiCache.get(cacheKey);
  } else {
    const response = await apiFunction(...apiArgs);
    apiCache.set(cacheKey, response);
    return response;
  }
};